import {  Box, Typography, Tooltip, Paper } from "@mui/material"
import { VerticalAlignBottom as VerticalAlignBottomIcon } from '@mui/icons-material';
import { downloadAttachment } from "../../../utils/helper";
import { trackActivity } from "../../../utils/mixpanel";
import UploadingIcon from "../../../shared_elements/components/UploadingIcon";

const AttachmentsSection = ({ attachmentData, slug=null, viewFileStatus, claim=null }) => {
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Shot Visit Attachments`, page_type: page_type, })
  }
  return (
    <Paper>
      <Box p={1} sx={{ backgroundColor: '#F8F8F8', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography fontWeight={500} fontSize={18}> Attachments </Typography>
        {(claim?.slug === slug) && <UploadingIcon viewFileStatus={() => viewFileStatus?.()} />}
      </Box>
      <Box>
        <Box className='headlines-box-style' sx={{ maxHeight: '169px' }}>
          {attachmentData?.length ?
            <>
              {attachmentData.map((item) =>
                <div style={{ minWidth: '350px', paddingLeft: "5px" }} >
                  {(() => {
                  let fileName = item?.file_name;
                  if (fileName) {
                    fileName = fileName.replace(/\.[^/.]+$/, '');
                    if (fileName.includes('_')) {
                      const parts = fileName.split('_');
                      parts.pop();
                      fileName = parts.join('_');
                    }
                  }
                    return (
                      <>
                        <ul style={{ cursor: 'pointer', gap: '6px' }} className="list-inline">
                          {/* <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "headlines", operationType: ['R'] }}> */}
                            <li >
                            <a onClick={() => { downloadAttachment(item?.download_url, item?.file_name); handleItemClicked('DownloadIcon') }} download={fileName}>
                                <Tooltip title="Download">  <VerticalAlignBottomIcon fontSize="small" color='primary' /></Tooltip>
                              </a>
                            </li>
                          {/* </PermissionWrapper> */}
                          <li >
                            <span style={{ verticalAlign: 'super' }}>{fileName}</span>
                          </li>
                        </ul>
                      </>
                    )
                  })()}
                </div>
              )}
            </> :
            <Typography sx={{ textAlign: "center", fontSize: 14, fontWeight: 500, }}> No Attachment Available </Typography>
          }
        </Box>
      </Box>
    </Paper>
  )
}

export default AttachmentsSection